import {
  StoreSubscribeResponse,
  StoreSubscriptionInput,
} from "../models/Subscription";
import { Client } from "../types/internal";

export const createSubscription = (client: Client) => ({
  subscribe: (input: StoreSubscriptionInput) => {
    return client.post<StoreSubscribeResponse>("subscriptions/subscribe", {
      data: input,
    });
  },
  unsubscribe: (email: string) => {
    return client.post<StoreSubscribeResponse>("subscriptions/unsubscribe", {
      data: { email },
    });
  },
});
